<div>
    <div *ngFor="let activity of protocol.activities; let index = index" class="result mat-elevation-z2 p-2 mb-4">
        <h3>{{(index + 1) + '. ' + activityTitle(activity)}}</h3>
        <ng-template resultsHost></ng-template>
    </div>
</div>
